export type {};

import './array';
import './date';
import './function';
import './number';
import './object';
import './regex';
import './set';
import './string';
import './window';
